import React from "react";
import projectImage from "../../asset/project image.png";
import { useParams } from "react-router-dom";
import { useGetProjectByIdQuery } from "../../Redux/getApi";

const ProjectDetails = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const { data, isLoading, isFetching, error } = useGetProjectByIdQuery(id, {
    refetchOnFocus: false,
    skip: !isEditMode,
  });
  console.log(data);

  return (
    <div>
      {isFetching || isLoading ? (
        <FeaturedProjectSkeleton />
      ) : (
        data?.project && (
          <div className="flex flex-col gap-10  lg:py-20 md:py-14 sm:py-10 py-8 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%]">
            <div className="flex items-center md:flex-row flex-col gap-10">
              <div className={`flex-1 flex flex-col gap-3 `}>
                <p className="md:text-[1.3rem] text-[1rem] text-[#00643b] font-semibold uppercase">
                  Featured Project
                </p>
                <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] text-[1.6rem]  font-bold">
                  {data?.project?.title}
                </h1>
                <p className="xl:text-[1.3rem] md:text-[1.1rem] text-[.95rem] text-[#7A7A7A]">
                  {data?.project?.content}
                </p>
              </div>
              <div className="flex-1 flex md:justify-end justify-center">
                <img
                  src={data?.project?.coverImage?.imageUrl}
                  className={`md:w-[85%] w-[90%] rounded-2xl `}
                  alt=""
                />
              </div>
            </div>
          </div>
        )
      )}
      {error && (
        <p className="text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.5rem] font-semibold text-[#000000] py-20">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

const FeaturedProjectSkeleton = () => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-6 p-4 lg:p-8 bg-gray-100 rounded-xl animate-pulse">
      {/* Text Section */}
      <div className="md:flex-1 w-full space-y-4">
        <div className="h-5 w-32 bg-gray-300 rounded"></div>{" "}
        {/* "FEATURED PROJECT" */}
        <div className="h-8 w-3/4 bg-gray-300 rounded"></div> {/* Title */}
        <div className="h-8 w-2/4 bg-gray-300 rounded"></div> {/* Title */}
        <div className="space-y-2">
          <div className="h-4 w-full bg-gray-300 rounded"></div>
          <div className="h-4 w-full bg-gray-300 rounded"></div>
          <div className="h-4 w-full bg-gray-300 rounded"></div>
          <div className="h-4 w-full bg-gray-300 rounded"></div>
          <div className="h-4 w-5/6 bg-gray-300 rounded"></div>
        </div>
      </div>

      {/* Image Section */}
      <div className="md:flex-1 w-full flex md:justify-end justify-center ">
        <div className="w-[75%]  aspect-[1/1.2] bg-gray-300 rounded-lg"></div>
      </div>
    </div>
  );
};
export default ProjectDetails;
